import popupStyles from "../errorPopup/errorPopup.module.css";
import { IPopupWithoutProps } from "../../../types/types";
import PaymentSection from "../../paymentSection/PaymentSection";
import { TUpdateQuestionnaireScoreTotalAmountRequest } from "../../../services/types/payment.types";
import { tWithKeyAttr as t } from "../../../i18nHelper";

function BulkAppointmentsReportsPopup({
  onSubmit,
  numberOfAppointments
}: IPopupWithoutProps & {
  onSubmit: (paymentInfo: TUpdateQuestionnaireScoreTotalAmountRequest) => Promise<void>;
  numberOfAppointments: number;
}) {
  return (
    <article className={popupStyles.popup}>
      <PaymentSection onSubmit={onSubmit} note={t("PAYMENT_POPUP_APPOINTMENTS_NOTE", { count: numberOfAppointments })} />
    </article>
  );
}

export default BulkAppointmentsReportsPopup;
